import clsx from "clsx"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import { useAppDispatch } from "@/store"
import { useUpdatePlayerSettingsMutation } from "@/store/apis/playerAPI"
import { setLanguage } from "@/store/slices/app"
import { SourceOption } from "@/ui/SourceOption"
import styles from "./LanguageSwitcher.module.scss"
import { ILanguageSwitcher } from "./index.ts"

export const LanguageSwitcher: FC<ILanguageSwitcher> = ({
  className,
  ...props
}) => {
  const dispatch = useAppDispatch()
  const { i18n } = useTranslation()

  const [updatePlayerSettings] = useUpdatePlayerSettingsMutation()

  const updateLanguage = (e: "uk" | "en" | "ru") => {
    if (i18n.language === e) return

    dispatch(setLanguage(e))
    updatePlayerSettings({ language: e })
  }

  return (
    <div className={clsx(styles.LanguageSwitcher, className)} {...props}>
      {(["uk", "en", "ru"] as const).map((e, i) => (
        <SourceOption
          onChange={() => updateLanguage(e)}
          isChosen={i18n.language === e}
          text={e.toUpperCase()}
          key={i}
        />
      ))}
    </div>
  )
}
